<script lang="ts" setup>
const DEFAULT_LOGO = "LogoTopFarmaciaOnline.svg"
const route = useRoute()
const isMounted = ref(false)

onMounted(() => (isMounted.value = true))

const { data, pending } = useFetch("/api/getHeaderLogo")

const currentPath = computed(() => (route ? route.path : ""))
const isHomePage = computed(() => currentPath.value !== "/")
const dynamicLogoUrl = computed(() => data.value?.url)
const defaultLogo = computed(() => !dynamicLogoUrl.value && DEFAULT_LOGO)
const loading = computed(() => !isMounted.value || pending.value)
</script>

<template>
  <div class="relative h-11 w-full max-w-[160px]">
    <div v-if="loading" class="absolute inset-0 z-10">
      <SkeletonLogo />
    </div>
    <AppLink to="/" :class="{ invisible: loading }">
      <h1 v-if="!isHomePage">
        <UtilsIcon
          fetch-priority="high"
          :preload="true"
          :name="defaultLogo"
          :forcedSrc="dynamicLogoUrl"
          class="h-11 w-40 flex-shrink-0 cursor-pointer"
          :altText="$t('general.topFarmaciaBest')"
          :titleText="$t('general.topFarmaciaBest')"
        />
        <span class="hidden">{{ $t("general.topFarmacia") }}</span>
      </h1>
      <UtilsIcon
        v-else
        fetch-priority="high"
        :preload="true"
        :name="defaultLogo"
        :forcedSrc="dynamicLogoUrl"
        class="h-11 w-40 flex-shrink-0 cursor-pointer"
        :altText="$t('general.topFarmaciaBest')"
        :titleText="$t('general.topFarmaciaBest')"
      />
    </AppLink>
  </div>
</template>
